// Extended from Sage's HOC handleLoading, Rule:
// 1. need to init a "setLoading" state and <Loading /> component outside
// 2. put business logic in callback
export const handlePageLoading = async (
  setLoading: (b: boolean) => void,
  callback: () => Promise<void>,
): Promise<void> => {
  setLoading(true);
  try {
    await callback();
  } finally {
    setLoading(false);
  }
};
